import React, { memo, ReactElement } from "react";
import { Center, HStack, Text } from "@chakra-ui/react";
import colors from "app/colors";

interface IProps {
  message: string;
  leftIcon?: ReactElement;
  rightElement?: ReactElement;
}

const Toast = ({ message, leftIcon, rightElement }: IProps) => (
  <Center>
    <HStack
      backgroundColor={colors.blackTertiary}
      height={50}
      borderRadius={7}
      p={2}
    >
      {leftIcon}
      <Text color={colors.white} fontSize={14}>
        {message}
      </Text>
      {rightElement}
    </HStack>
  </Center>
);

export default memo(Toast);
